import { getAuthHeaders } from "modules/common";
import { createService } from "services/serviceFactory";
import {
    BulkEditEducationDocumentRequest,
    CreateEducationDocumentCategoryRequest,
    CreateEducationDocumentRequest,
    EditEducationDocumentRequest,
    GetEducationDocumentRequest,
} from "./request";
import { EducationDocument } from "./response";

const educationDocumentService = createService("educationdocuments");

async function getEducationDocuments(request: GetEducationDocumentRequest, accessToken: string) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.get(
        "/educationdocuments/v1/educationdocuments/",
        {
            params: request,
            ...authHeaders,
        }
    );
    return response.data;
}

async function createEducationDocument(
    data: CreateEducationDocumentRequest,
    file: File | null,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const formData = new FormData();
    formData.append("educationDocumentJson", JSON.stringify(data));
    if (file) {
        formData.append("formFile", file, file.name);
    }
    const response = await educationDocumentService.post(
        "/educationdocuments/v1/educationdocuments/",
        formData,
        authHeaders
    );
    return response.data;
}

async function editEducationDocument(
    data: EditEducationDocumentRequest,
    file: File | null,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const formData = new FormData();
    formData.append("educationDocumentJson", JSON.stringify(data));
    if (file) {
        formData.append("formFile", file, file.name);
    }
    const response = await educationDocumentService.patch<EducationDocument>(
        `/educationdocuments/v1/educationdocuments/`,
        formData,
        authHeaders
    );
    return response.data;
}

async function bulkEditEducationDocuments(
    data: BulkEditEducationDocumentRequest,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.patch(
        `/educationdocuments/v1/educationdocuments/bulk`,
        data,
        authHeaders
    );
    return response;
}

async function deleteEducationDocument(guid: string, accessToken: string) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.delete(
        `/educationdocuments/v1/educationdocuments/${guid}`,
        authHeaders
    );
    return response;
}

async function bulkDeleteEducationDocuments(educationDocumentGuids: string[], accessToken: string) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.delete<EducationDocument>(
        `/educationdocuments/v1/educationdocuments/bulk`,
        {
            params: { educationDocumentGuids },
            ...authHeaders,
        }
    );
    return response.data;
}

async function getEducationDocumentCategories(accessToken: string) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.get(
        "/educationdocuments/v1/educationdocuments/categories",
        authHeaders
    );
    return response.data;
}

async function createEducationDocumentCategory(
    data: CreateEducationDocumentCategoryRequest,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.post(
        "/educationdocuments/v1/educationdocuments/categories",
        data,
        authHeaders
    );
    return response.data;
}

async function editEducationDocumentCategory(
    data: CreateEducationDocumentCategoryRequest,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.patch(
        "/educationdocuments/v1/educationdocuments/categories",
        data,
        authHeaders
    );
    return response.data;
}

async function deleteEducationDocumentCategory(guid: string, accessToken: string) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await educationDocumentService.delete(
        `/educationdocuments/v1/educationdocuments/categories/${guid}`,
        authHeaders
    );
    return response;
}

export {
    getEducationDocuments,
    createEducationDocument,
    editEducationDocument,
    bulkEditEducationDocuments,
    deleteEducationDocument,
    bulkDeleteEducationDocuments,
    getEducationDocumentCategories,
    createEducationDocumentCategory,
    editEducationDocumentCategory,
    deleteEducationDocumentCategory,
};
